var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    width: 26,
    height: 26,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1.5 0h23c0.8 0 1.5 0.9 1.5 2.1v21.8c0 1.1-0.6 2-1.5 2h-23c-0.8 0-1.5-0.9-1.5-2v-21.8c0-1.2 0.7-2.1 1.5-2.1zm-0.4 23l8.1-11.1-8.1-9.1zm9-10.2l-8.3 11.5h22.3l-7.9-11.5-2.6 3.1c-0.2 0.2-0.5 0.3-0.8 0zm7-1l7.8 11.3v-20.5zm-15.2-10.2l11.3 12.7 10.9-12.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailWhite);
export default __webpack_public_path__ + "static/media/email-white.8a7fd8813527ee991a2ff6ac149ade58.svg";
export { ForwardRef as ReactComponent };